<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_COMPONENT_PP_719'
        )
      }"
    >
      <p class="content-s-2-label">
        <label
          >Является ли продукция проекта комплектующим к указанной в ПП РФ от
          17.07.2015 № 719:</label
        >
      </p>
      <select
        v-model="$parent.project.UF_IS_COMPONENT_PP_719"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="changeComponent()"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option :value="1">Да</option>
        <option :value="0">Нет</option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_IS_COMPONENT_PP_719"
          )
        }}
      </div>
    </div>
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_NAME_END_PRODUCT'
        )
      }"
    >
      <div
        v-if="project.UF_IS_COMPONENT_PP_719"
        class="col-xs-12 mycol"
        v-bind:class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_NAME_END_PRODUCT'
          )
        }"
      >
        <p class="content-s-2-label">
          <label>Укажите наименование конечной продукции проекта:</label>
        </p>
        <div class="info-holder-container">
          <textarea
            v-on:keyup="
              $parent.$parent.removeError(
                'PROJECTS',
                'LOGIC',
                'UF_NAME_END_PRODUCT'
              )
            "
            class="i-main-style t-dop-style i-wid-50"
            style="height:114px;"
            v-model="$parent.project.UF_NAME_END_PRODUCT"
            :disabled="$parent.$parent.projectDisabled"
            placeholder=""
          />
        </div>
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_NAME_END_PRODUCT"
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "uf_component_pp_719",
  computed: {
    ...mapGetters(["directory", "project"])
  },
  methods: {
    changeComponent() {
      this.$parent.project.UF_N_PRODUCTION_ID = "";
      this.$parent.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_VID_PRODUCTION_ID"
      );
    }
  }
};
</script>

<style scoped></style>
